import { z } from 'zod';

/** A zone as the apps list it (`select id, name from zones`). */
export const ZoneSummarySchema = z.object({
  id: z.number().int().positive(),
  name: z.string().min(1),
});
export type ZoneSummary = z.infer<typeof ZoneSummarySchema>;

export const ZoneSummaryListSchema = z.array(ZoneSummarySchema);
